// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","wrapper":"link_wrapper__tF6ZG","disabled":"link_disabled__sS25r"};